


import React, { useState, useEffect } from 'react';
import ModalCommon from "../../ModalCommon";
import { Row, Col } from "olive-react-myoneui";
import Form from "olive-react-myoneui/lib/Form";
import Button from "olive-react-myoneui/lib/Button";

const ModalShare = ({ showModal, closeModal, shareDocuments, shareItemDetail }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData]  = useState({
        email:"",
        accessType: "2",
        sharePermission: false
    });

    useEffect(() => {
        if (shareItemDetail) {
            setFormData({
                email: shareItemDetail.email || "",
                accessType: shareItemDetail.itemAccessType || "2",
                sharePermission: shareItemDetail.itemSharePermission == '1' ? true : false
            });
        }
    }, [shareItemDetail])

    if (!showModal && !shareItemDetail) return null;
    
    // Validate email address format
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };


    // Handle input change
    const handleInputChange = (e) => {
        const {name, value, type, checked} =  e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));

        if((name === "email") && value === "") {
            setErrorMessage('Email cannot be empty');
        }
        if(name === "email" && value.length > 0) {
            if (validateEmail(value)) {
                setErrorMessage('');
            } else {
                setErrorMessage('Please enter a valid email address');
            }
        }
    };

    //handle form submit action
    const handleSave = (e) => {
        e.preventDefault();
        if(formData.email === ''){
            setErrorMessage('Please enter a valid email address');
        }
        if(errorMessage !== ''){
            return;
        }
        shareDocuments(formData,shareItemDetail);
    };

    return (
        <ModalCommon
            backdrop="static"
            show={showModal}
            onClose={closeModal}
            title={'Share '+shareItemDetail.itemName}
            className="myk__stu-question-modal"
            backdropOption="static"
        >
            <Form>
                <Row>
                    <Col className="text-start">
                        <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Email address(es)</Form.Label>
                            <Row className="align-items-center">
                                <Col>
                                <Form.Control
                                    type="text"
                                    name="email"
                                    placeholder="Enter user email address"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                </Col>
                            </Row>
                            {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-start">
                        {shareItemDetail && shareItemDetail.itemAccessType == '1' && 
                            <div>
                                <label className="opacity-0">Access Type</label>
                                <h4>Editor</h4>
                                <input type="radio" name="accessType" value="1"  checked={formData.accessType == '1'} onChange={handleInputChange} />
                            </div>
                        }
                        {shareItemDetail && (shareItemDetail.itemAccessType == '1' || shareItemDetail.itemAccessType == '2') && 
                            <div>
                                <h4>Viewer</h4>
                                <input type="radio" name="accessType" value="2" checked={formData.accessType == '2'} onChange={handleInputChange} />
                            </div>
                        }
                        
                    </Col>
                </Row>
                {shareItemDetail && shareItemDetail.itemSharePermission == '1' && 
                    <Row>
                        <Col className="text-start">
                            <label>Additional Permissions</label>
                            <h4>Share</h4>
                            <input type="checkbox" name="sharePermission" onChange={handleInputChange} checked={formData.sharePermission}/>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col className="text-end mt-3">
                        <Button variant="default" onClick={closeModal}>Cancel</Button>
                        <Button variant="primary" className="btn-round" onClick={handleSave} type="submit">Update</Button>
                    </Col>
                </Row>
            </Form>
        </ModalCommon>
    );
}

export default ModalShare;
